<!--
 * @Descripttion: ''
 * @Author: lilong(lilong@hztianque.com)
 * @Date: 2020-07-20 11:26:01
 * @LastEditTime: 2020-07-20 14:12:02
-->
<template>
  <div class="bread-crumd">
    <Breadcrumb>
      <BreadcrumbItem
      :to="item.path"
      v-for="(item,index) in list"
      :key="index">
      {{item.title}}
      </BreadcrumbItem>
    </Breadcrumb>
  </div>
</template>

<script>
export default {
  name: 'BreadCrumb',
  props: {
    list: {
      type: Array,
    },
  },
}
</script>

<style lang='scss' scoped>
.bread-crumd {
  /deep/.ivu-breadcrumb a {
    color: #666;
  }
  /deep/.ivu-breadcrumb-item-separator {
    color: #999;
  }
}
</style>